@defer (on viewport) {
	<nav class="footer-nav" @deferState>
		<app-logo-context-menu></app-logo-context-menu>
		<a href="mailto:create@nhdsgn.com">create&#64;nhdsgn.com</a>
		<span>646.348.4526</span>
		<div class="footer-legal">
			<a class="textlink" [href]="'privacy'">Privacy Policy</a>
			<a class="textlink" [href]="'terms-of-use'">Terms of Use</a>
			<a class="textlink" [href]="'cookies'">Cookie Policy</a>
		</div>
	</nav>
} @placeholder {
	<div class="defer-ph"></div>
}
